<template>
  <div class="form-control">
    <div v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control opciones">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{ this.obtenerNombreDeSeleccionSingular() }}</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} {{ this.obtenerNombreDeSeleccionPlural() }}</option>        
        <option v-for="(paginaWeb,index) in micrositios" :value="paginaWeb.PaginaDeInicioId" :key="index">{{paginaWeb.Titulo}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        micrositios: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      obtenerNombreDeSeleccionSingular: function() {
        if(this.parametros.TipoPaginaId == null || this.parametros.TipoPaginaId == undefined || this.parametros.TipoPaginaId < 1 || this.parametros.TipoPaginaId == 3) {
          return 'Micrositio'
        }
        else
          return `${ this.tipo.Nombre } la página de inicio.`
      },
      obtenerNombreDeSeleccionPlural: function() {
        if(this.parametros.TipoPaginaId == null || this.parametros.TipoPaginaId == undefined || this.parametros.TipoPaginaId < 1) {
          return 'los Micrositios'
        }
        else
          return 'las páginas de inicio.'
      },

      cambiarDatos(evento){
        
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }
        this.$store.dispatch("A_SICPO_Catalogo_001PaginaInicio",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento);
        // para obtener label del select => let labelTipoPagina = evento.target.options[evento.target.selectedIndex].text;
      },
      


      cargarPaginasWeb: function() {
        // definimos metodo de API
    
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SICPO.catalogos.C001PaginaDeInicio;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        if(this.parametros.TipoPaginaId == null || this.parametros.TipoPaginaId == undefined || this.parametros.TipoPaginaId < 1)
          this.parametros.TipoPaginaId = 3;

        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetPaginasWebAPI = this.parametros;
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionMetodoGetPaginasWebAPI,headerPeticion)
                .then(respuesta => {                          
                    if (respuesta.data.SiHayError) {             
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        this.micrositios = respuesta.data.PaginasDeInicio;
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {       
                  console.log(" error::",excepcion)         
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SICPO_Catalogo_001PaginaInicio", valoresDelCatalogo);
      this.$store.dispatch("A_SICPO_Catalogo_013PaginaMicrositio",{llave: 'catalogoPaginaMicrositioPasoUno',valor: -1});

    },
    created() {
      this.cargarPaginasWeb();
    }
  }
</script>
<style scoped>
.opciones{
  font-size: 1em !important;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Catalogos/C001PaginaInicio.vue